import ReactDOM from 'react-dom/client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './index.css';
import { captchaService } from './service/capcha.service';
import RootErrorBoundary from './components/RootErrorBoundary';

console.log('1 - imports finished');
import App from './App';
try {
    console.log('2 - creating QueryClient');
    const queryClient = new QueryClient();
    console.log('3 - QueryClient created');

    // 🔗 Global Turnstile callback
    (window as any).onCaptchaSolved = (token: string) => {
        captchaService.setToken(token);
    };
    console.log('4 - onCaptchaSolved attached to window');

    const root = document.getElementById('root');
    console.log('5 - root element found:', !!root);

    const app = ReactDOM.createRoot(root!);
    console.log('6 - createRoot OK');

    app.render(
        <RootErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </RootErrorBoundary>
    );
    console.log('7 - render() called (React work may still be async after this)');
} catch (e) {
    console.error('MAIN FAILED —', e);
    console.error('Stack:', (e as Error)?.stack);
}
